import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Fichier from './Fichier';
import withLoader from '../withLoader';
import { fetchFichier } from 'store/fichier/fichierActions';
import { downloadFichier } from 'store/fichier/fichierActions';

const FichierWithLoader = withLoader(Fichier);

class FichierContainer extends React.Component {

    state = {
        isLoading: true,
        fichier: null
    };

    async componentDidMount() {
        let fichier = await this.props.fetchFichier(this.props.fichierId);

        this.setState({ isLoading: false, fichier: fichier });
    }

    async componentDidUpdate(prevProps) {


        if (prevProps.fichierId !== this.props.fichierId) {
            this.setState({ isLoading: true });

            let fichier = await this.props.fetchFichier(this.props.fichierId);

            this.setState({ isLoading: false, fichier: fichier });
        }

    }


    handleClick = async () => {
        this.setState({isDownloading: true});
        await this.props.downloadFichier(this.props.fichierId);
        this.setState({ isDownloading: false });
    }

    render() {

        let { autorise, variant, color, size, label } = this.props;
        let { isLoading, isDownloading } = this.state;

        if (autorise === undefined || autorise === null) {
            autorise = true;
        }


        return <FichierWithLoader
            isLoading={isLoading}
            isDownloading={isDownloading}
            fichier={this.state.fichier}
            onClick={this.handleClick}
            autorise={autorise}


            variant={variant}
            color={color}
            size={size}
            label={label}

        />;
    }
}

FichierContainer.propTypes = ({
    fichierId: PropTypes.number.isRequired,
    autorise: PropTypes.bool,

    variant: PropTypes.string,
    color: PropTypes.string,
    size: PropTypes.string,
    label: PropTypes.string,
});


FichierContainer.defaultProps = {
    variant: "outlined",
    color: "primary",
    size: "small",
    label: "",
};

const mapDispatchToProps = dispatch => ({
    fetchFichier: id => dispatch(fetchFichier(id)),
    downloadFichier: id => dispatch(downloadFichier(id))
});

export default connect(null, mapDispatchToProps)(FichierContainer);